import CONSTANT from "../../constants/constant";
import { usePlaylist } from "../../contexts/playlistContext";
import usePlayListStore from "../../stores/playlistStore";
import Button from "../Button";
import StyledParagraph from "../Utils/Paragraph.styled";
import Stack from "../Utils/Stack.styled";
import Title from "../Utils/Title.styled";
import {
  VideoDetailsContainer,
  VideoThumbnail,
  ThumbnailImage,
  Tag,
  DescriptionContainer,
} from "./VideoDetails.styled";
import { motion } from "framer-motion";

export const VideoDetails = ({
  videoId,
  title,
  thumbnail,
  owner,
  views,
  datePublished,
  genre,
  description,
  thumbnailUrl,
}) => {
  const { setCurrentSelectedVideoDetails } = usePlaylist();
  const checkVideoInPlaylist = usePlayListStore(
    (state) => state.checkVideoInPlaylist
  );

  const getDate = () => {
    let options = { year: "numeric", month: "long", day: "numeric" };
    const date = new Date(datePublished);
    return date.toLocaleDateString("en-US", options);
  };

  const openPlaylistModal = () => {
    checkVideoInPlaylist(videoId);
    setCurrentSelectedVideoDetails({
      videoId: videoId || "",
      title: title,
      thumbnailUrl: thumbnailUrl || "",
    });
  };

  const ButtonSection = () => {
    return (
      <Stack gap="8" width="fit-content">
        <Button
          onClick={openPlaylistModal}
          type={CONSTANT.ICON.ADD_TO_PLAYLIST}
          label="Add to playlist"
        />
      </Stack>
    );
  };

  const TitleDetail = () => {
    return (
      <Stack direction="row" gap="8" alignItems="center">
        <Title size="22px">{title}</Title>
        <Tag textAlign="center">{genre}</Tag>
      </Stack>
    );
  };

  const HeaderDetail = () => {
    return (
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <TitleDetail />
        <ButtonSection />
      </Stack>
    );
  };

  const VideoInfo = () => {
    return (
      <Stack
        direction="row"
        gap="16"
        justifyContent="start"
        alignItems="center"
      >
        <VideoThumbnail>
          <ThumbnailImage img={thumbnail} />
        </VideoThumbnail>
        <Stack
          direction="column"
          gap="8"
          justifyContent="center"
          alignItems="start"
          width="fit-content"
        >
          <Title size="16px">{owner}</Title>
          <StyledParagraph>Published: {getDate()}</StyledParagraph>
        </Stack>
      </Stack>
    );
  };

  const ViewInfo = () => {
    return (
      <Stack width="100%" justifyContent="end" alignItems="center">
        <Title size="16px" textAlign="end">
          {Number(views).toLocaleString()} Views
        </Title>
      </Stack>
    );
  };

  const DescriptionInfo = () => {
    return (
      <DescriptionContainer>
        <Stack direction="column" gap="8">
          <Title size="14px">Description</Title>
          <StyledParagraph>{description}</StyledParagraph>
        </Stack>
      </DescriptionContainer>
    );
  };

  return (
    <VideoDetailsContainer
      as={motion.div}
      key={title}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        duration: 1.5,
      }}
    >
      <Stack
        direction="column"
        gap="16"
        justifyContent="center"
        alignItems="start"
      >
        <HeaderDetail />
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <VideoInfo />
          <ViewInfo />
        </Stack>
        <DescriptionInfo />
      </Stack>
    </VideoDetailsContainer>
  );
};

export default VideoDetails;
